import Axios from 'axios'
import Config from '../config/config';

function authorize(route) {
    return Axios.post(`${Config.localApiURL}authorization/authorize`, {
        token: localStorage.getItem("jwt"),
        path: route,
        projectId: Config.projectId
    }).then(res => {
        return res;

    });
}

function getMenu() {
    return Axios.get(`${Config.localApiURL}authorization/getMenu/${Config.projectId}?token=${localStorage.getItem("jwt")}`).then(res => {
        return res;

    });
}

export const authorizationService =
    {
        authorize,
        getMenu
    }


// WEBPACK FOOTER //
// ./src/authorization/authorizationService.js